import { BACKGAMON, DOMINO, SPADES, RUMMY_RUSH, RUMMY_STAR, TILEZ } from '../constants/products';

const getProduct = () => {
  const url = window.location.href;
  switch (true) {
    case url.includes('bbumgames') || url.includes('bg'):
      return BACKGAMON;
    case url.includes('domino'):
      return DOMINO;
    case url.includes('spades'):
      return SPADES;
    case url.includes('rush'):
      return RUMMY_RUSH;
    case url.includes('stars'):
      return RUMMY_STAR;
    case url.includes('tilez'):
      return TILEZ;
  }
};

export default getProduct;
